import { EImagePosition } from '@/components/atoms/at-media/at-media.types';
import useBreakpoint from './useBreakpoint';

export interface IResponsiveProps<T> {
  desktop: T;
  mobile: T;
  tablet: T;
}

const useResponsiveProp = (
  sources: IResponsiveProps<EImagePosition | string>,
): string => {
  const breakpoint = useBreakpoint();

  if (typeof sources === 'string') {
    return sources;
  }

  const getResponsiveProp = () => {
    if (!breakpoint) return '';
    if (
      (breakpoint === 'lg' ||
        breakpoint === 'xl' ||
        breakpoint === '2xl' ||
        breakpoint === '3xl') &&
      sources?.desktop
    ) {
      return sources.desktop;
    } else if (breakpoint === 'md' && sources?.tablet) {
      return sources?.tablet;
    } else if (breakpoint === 'sm' || breakpoint === 'xs') {
      return sources?.mobile; // Mobile is the default
    }

    if (sources?.tablet) {
      return sources?.tablet;
    } else if (sources?.desktop) {
      return sources?.desktop;
    }

    return sources?.mobile;
  };

  return getResponsiveProp();
};

export default useResponsiveProp;
